import { Star } from "lucide-react";

/**
 * Star badge shown next to a business name to indicate they are an active
 * servrevu Pro subscriber. Cosmetic only — does NOT affect directory ranking.
 */
export default function ProBadge({ size = 16, className = "", showLabel = false }) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-amber-500 ${className}`}
      title="servrevu Pro subscriber"
      aria-label="Pro Subscriber"
      data-testid="pro-badge"
    >
      <Star size={size} className="fill-amber-400 text-amber-500" strokeWidth={2} />
      {showLabel && <span className="text-xs font-medium">Pro</span>}
    </span>
  );
}
